var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { useCreateFormTemplate } from '../FormTemplate.hooks';
import { ConfigFieldControl } from '@sierralabs/core-ui';
import { Autocomplete } from '@material-ui/lab';
import { useEntityContext } from '@sierralabs/entity-ui';
export const FormTemplateCreateDialog = ({ open, formTemplate, onCancel, onCreated }) => {
    // const [isCreateSchema, setIsCreateSchema] = useState(false);
    const [formValues, setFormValues] = useState({});
    const { entities } = useEntityContext();
    const dynamicEntities = useMemo(() => entities === null || entities === void 0 ? void 0 : entities.filter(e => e.id), [entities]);
    const entity = useMemo(() => dynamicEntities === null || dynamicEntities === void 0 ? void 0 : dynamicEntities.find(e => e.id === formValues.entityId ||
        (formTemplate && e.id === formTemplate.entityId)), [dynamicEntities, formValues.entityId, formTemplate]);
    // console.log('entity', entity);
    const onCreatedRef = useRef(onCreated);
    // const [searchValue, setSearchValue] = useState('');
    // const {
    //   formSchemaList,
    //   isLoading: loadingFormSchemas,
    //   loadingError,
    //   findFormSchemas
    // } = useFindFormSchemas();
    // useEffect(() => findFormSchemas(), [findFormSchemas]);
    // const formSchemaOptions = useMemo(
    //   () => [
    //     ...(formSchemaList?.data || []),
    //     { id: 0, name: `+ Create new schema` }
    //   ],
    //   [formSchemaList?.data]
    // );
    const { createdFormTemplate, isCreating, createError, createFormTemplate } = useCreateFormTemplate();
    useEffect(() => {
        var _a;
        if (createdFormTemplate) {
            (_a = onCreatedRef.current) === null || _a === void 0 ? void 0 : _a.call(onCreatedRef, createdFormTemplate);
        }
    }, [createdFormTemplate]);
    // useEffect(() => {
    //   if (!isCreating) {
    //     if (onCreated && createdFormTemplate) {
    //       onCreated(createdFormTemplate);
    //     }
    //     if (formikRef && formikRef.current) {
    //       formikRef.current.setSubmitting(false);
    //     }
    //   }
    // }, [createdFormTemplate, isCreating, onCreated]);
    return (React.createElement(Dialog, { maxWidth: 'xs', open: open, onClose: onCancel, fullWidth: true },
        React.createElement(DialogTitle, null,
            formTemplate ? 'Duplicate' : 'Create',
            " Form Template"),
        React.createElement("form", { autoComplete: 'off', onSubmit: event => {
                event.preventDefault();
                if (formValues.name && formValues.entityId) {
                    // omit id from formTemplate if provided
                    const _a = formTemplate || {}, { id } = _a, formTemplateCopy = __rest(_a, ["id"]);
                    createFormTemplate(Object.assign(Object.assign({}, formTemplateCopy), formValues));
                }
            } },
            React.createElement(DialogContent, null,
                React.createElement(ConfigFieldControl, null,
                    React.createElement(TextField, { autoFocus: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Form Template Name', value: formValues.name || (formTemplate === null || formTemplate === void 0 ? void 0 : formTemplate.name) || '', onChange: event => setFormValues(Object.assign(Object.assign({}, formValues), { name: event.target.value })) })),
                React.createElement(ConfigFieldControl, null,
                    React.createElement(Autocomplete, { fullWidth: true, value: entity || null, 
                        // getOptionSelected={(entity, value) => {
                        //   return entity.id === value;
                        // }}
                        getOptionLabel: entity => {
                            return entity.name;
                            // if (typeof schemaOrId === 'number') {
                            //   return (
                            //     formSchemaOptions.find(o => o.id === schemaOrId)?.name ||
                            //     ''
                            //   );
                            // } else {
                            //   return schemaOrId?.name || '';
                            // }
                        }, options: dynamicEntities || [], 
                        // onSearch={value => {
                        //   setSearchValue(value);
                        //   findFormSchemas({ limit: 100, search: value });
                        // }}
                        // getSelectedValue={schema => schema.id}
                        onChange: (_, entity) => {
                            // setIsCreateSchema(value?.id === 0);
                            if (entity) {
                                setFormValues(Object.assign(Object.assign({}, formValues), { entityId: entity.id }));
                            }
                            // const values = formikRef.current?.values;
                            // if (!values.formSchemaName) {
                            //   formikRef.current?.setValues({
                            //     ...values,
                            //     formSchemaName: values.name
                            //   });
                            // }
                        }, renderInput: params => (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Entity Schema', helperText: 'Pick an entity to store the data captured from the form' }))) })),
                createError && (React.createElement(Alert, { severity: 'error' }, `Error occurred. ${createError.message}`))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: onCancel }, "Cancel"),
                React.createElement(Button, { variant: 'contained', type: 'submit', disabled: !formValues.name || !formValues.entityId, endIcon: isCreating && React.createElement(CircularProgress, { size: 20 }) }, formTemplate ? 'Duplicate' : 'Create')))));
};
export default FormTemplateCreateDialog;
//# sourceMappingURL=FormTemplateCreateDialog.js.map